import { ApplicationDataActions, ApplicationDataActionTypes } from './applicationDataActions';
import { ApplicationState } from './../../models/ApplicationState';
import { defaultFormState } from './formDataReducer';
import { defaultSubmissionState } from '../submission/submissionDataReducer';

export const defaultApplicationState: ApplicationState = {
        formState: defaultFormState,
        message: '',
        submissionState: defaultSubmissionState,
        applicationDataLoading: false,
        applicationDataLoadingFailure: false,
        applicationDataLoadingSuccess: false,
};

export const applicationDataReducer = (state: ApplicationState = defaultApplicationState, action: ApplicationDataActions):
 ApplicationState => {
    switch(action.type) {
        case ApplicationDataActionTypes.APPLICATION_LOAD_SUCCESS: return {
            ...state,
            message: action.data,
            applicationDataLoading: false,
            applicationDataLoadingFailure: false,
            applicationDataLoadingSuccess: true,
        };
        case ApplicationDataActionTypes.APPLICATION_LOAD_FAILURE: return {
            ...state,
            message: action.data || '',
            applicationDataLoading: false,
            applicationDataLoadingFailure: true,
            applicationDataLoadingSuccess: false,
        };
        default: return state;
    }
}